import { supabase } from "supabase";

export default async function insertExtraFields({ insertedProfiles, additionalDataMap, getProfileKey, getFieldByKey }) {
  if (!additionalDataMap.size) return;

  const updateRecord = (recordsMap, profileId, fieldKey, fieldValue) => {
    const record = recordsMap.get(profileId) ?? { influencer_id: profileId };
    record[fieldKey] = fieldValue;
    recordsMap.set(profileId, record);
  };

  const dataByTable = {};

  // Group by table
  for (const profile of insertedProfiles) {
    const extraFields = additionalDataMap.get(getProfileKey(profile));
    if (!extraFields) continue;

    for (const [fieldKey, fieldValue] of Object.entries(extraFields)) {
      const field = getFieldByKey({ columnKey: fieldKey });
      if (field?.db_table && field.db_table !== "influencers") {
        const recordsMap = dataByTable[field.db_table] ??= new Map();
        updateRecord(recordsMap, profile.id, fieldKey, fieldValue);
      }
    }

    Object.assign(profile, extraFields);
  }

  // Parallel insert
  await Promise.all(
    Object.entries(dataByTable).map(([table, recordsMap]) =>
      supabase.from(table).insert(Array.from(recordsMap.values()))
        .then(({ error }) => {
          if (error) console.error(`Failed to insert ${table} data:`, error);
        })
    )
  );
}
